import React, {useState} from "react";
import {fetchOauthAuthorize} from "../services/api";
import ProgressButton from "../components/generic/ProgressButton";
import {API_BASE_URL} from "../config/api";

function AuthForm(data: any) {
  const searchParams = new URLSearchParams(window.location.search);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const client_id = searchParams.get("client_id") || "";
  const redirect_uri = searchParams.get("redirect_uri") || "";
  const response_type = searchParams.get("response_type") || "";
  const scope = searchParams.get("scope") || "";
  const state = searchParams.get("state") || "";

  const authorizeHandler = async (
    event?: React.MouseEvent<HTMLButtonElement>
  ) => {

    if (event) {
      event.preventDefault();
    }

    setIsSubmitting(true);

    const authRedirect: any = await fetchOauthAuthorize({
      client_id: client_id,
      redirect_uri: redirect_uri,
      response_type: response_type,
      scope: scope,
      state: state
    });
    window.location.href = authRedirect.redirect;
  };

  if (data.data) {
    if (!client_id || !redirect_uri || !response_type) {
      if (data.data['linked']) {
        return (<div>
          <h1>Authorization</h1>
          <p>You are logged in and <strong>{data.data['client_name']}</strong> is authorised to use your data</p>
        </div>);
      } else {
        return (<div>
          <h1>Authorization</h1>
          <p>You are logged in, but <strong>{data.data['client_name']}</strong> is not authorised to use your data.
            Please connect via your Oauth2 client</p>

          <h2>Settings</h2>
          <ul>
            <li>
              Authorization URL: {API_BASE_URL}/oauth/authorize
            </li>
            <li>
              Access token URL: {API_BASE_URL}/oauth/token
            </li>
            <li>
              Client ID: untamed
            </li>
          </ul>
        </div>);
      }
    }

    if (data.data['linked']) {
      return (<div>
        <h1>Authorization</h1>
        <p>Renew your authorization code with <strong>{data.data['client_name']}</strong></p>
        <ProgressButton
          onClick={authorizeHandler}>
          Renew authorization
        </ProgressButton>
      </div>);
    } else {
      return (<div>
        <h1>Authorization</h1>
        Unlinked
        <h2>Allow <strong>{data.data['client_name']}</strong> to access your profile?</h2>
        <ProgressButton
          disabled={isSubmitting}
          onClick={authorizeHandler}
          inProgress={isSubmitting}>
          Authorize
        </ProgressButton>
      </div>);
    }
  } else {
    return (<div>
      <h1>Authorization</h1>
      <p>Loading...</p>
    </div>);
  }
};
export default AuthForm;
